import { createSelector } from 'reselect';

import {
  DashboardHub,
  dashboardHubState,
} from 'selectors/dashboards/dashboard-hub';

import { Filter, Value } from './filters-definintions';

export const widgetFiltersSelector = state =>
  state.widgetFilters ? state.widgetFilters.filters : [];
export const widgetFiltersTotalSelector = state =>
  state.widgetFilters ? state.widgetFilters.filtersCount : {};
export const widgetFiltersLoadingSelector = state =>
  state.widgetFilters ? state.widgetFilters.loading : false;
export const isUserSavingWidgetFiltersSelector = state =>
  state.widgetFilters ? state.widgetFilters.isUserSavingFilters : false;
export const widgetFilterValuesSelector = (filterId: string) => state =>
  state.widgetFilters
    ? state.widgetFilters.filters.find((f: Filter) => f.id === filterId).values
    : [];
export const allWidgetFilterSelectedValuesSelector = state =>
  state.widgetFilters
    ? state.widgetFilters.filters
        .filter((f: Filter) => f.values && f.values.find(v => v.selected))
        .map((f: Filter) => {
          return {
            ...f,
            values: f?.values?.filter((v: Value) => v.selected),
          };
        })
    : [];

export const selectWidgetPersistedFilters = (id: number) =>
  createSelector(
    dashboardHubState,
    (dashboardHub: DashboardHub) =>
      dashboardHub.widgetV3ById[id]?.filterData || {},
  );
